import React from 'react';
// import ReactDom from 'react-dom';
import styled from "styled-components";
import { deviceSize } from "../responsive";
// import { useMediaQuery } from "react-responsive";
import emailjs from "emailjs-com";



 const FormContainer =styled.div`
  /* position:relative; */
  width: 307px;
  height: 768px;
  padding: 67px 29px 30px; 
  background:${({Bg}) => ( Bg ? 'rgba(255, 255, 255, 0.3)':'linear-gradient(180deg, rgba(162, 56, 56, 0.35) 0%, rgba(234, 209, 208, 0.00) 125%);')};
  padding: 67px 29px 30px;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.65);
  border-radius: 0px 0px 50px 50px;
  left:${({lsize}) => (lsize ? lsize + "px" : "262px")};
  bottom:${({bsize}) => (bsize ? bsize +"px" : "187px")};
  top: 40px;
  backdrop-filter: blur(8px);



 @media screen and (max-width: ${deviceSize.laptop}px){

     left: 2%;

   }

   @media screen and (max-width: ${deviceSize.slaptop}px){

     left: 0%;

   }



  @media screen and (max-width: ${deviceSize.tablet}px) {
    

    }

 @media screen and (max-width: ${deviceSize.mobile}px){
  		position:relative;
  	  background:rgb(235, 213, 213);
  	  top: 19px;
  	  border-radius: 5% 5% 5% 5%;
  	  width:217px;
      height:484px;
      padding: 20px 29px 30px;;

	  }



 `;

const BusinessInquiries= styled.h1`
  width: 100%;
  height: 33px;
  margin: 0 14px 15px 15px;
  font-family: Sunflower;
  font-size: 28px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;

@media screen and (max-width: ${deviceSize.mobile}px){

  		font-weight: 500;
		font-size: 17px;
		line-height: 21px;
		margin: 0 0 0 0;
		text-align: center;
		margin-bottom: 15px;
 }

`;




const Line= styled.p`
  width: 249px;
  height: 23px;
  margin: 15px 0 49px;
  opacity: 0.85;
  font-family: Sunflower;
  font-size: 18px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align:left;
  color: #000;


@media screen and (max-width: ${deviceSize.mobile}px){

		font-weight:100;
		font-size: 11px;
    	text-align:center;
		display: flex;
		margin-bottom: 20px;
 }

`;



const InputForm =styled.input`
  width: 248px;
  height: 38px;
  margin: 20px 0 0px 1px;
  border-radius: 10px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.5);
  background-color: #fff;
  padding-left: 10px;

@media screen and (max-width: ${deviceSize.mobile}px){
		width: 154px;
  	height: 24px;
 }

`;

const TxA =styled.textarea`
  margin: 20px 0 0px 1px;
  border-radius: 10px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.5);
  background-color: #fff;
  font-family: Sunflower;
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #7b7b7b;
  width:250px;
  height: 116px;
  padding-left: 10px;
  padding-top: 10px;

	@media screen and (max-width: ${deviceSize.mobile}px){
		
		width: 153px;
  	height: 73px;

 }

`;



const SubmitButton =styled.button`
  
  width: 248px;
  height: 45px;
  flex-grow: 0;
  margin: 30px 0 0 1px;
  padding: 9px 89px 9px 88px;
  border-radius: 50px;
  border: solid 1px #fff;
  background-color: rgba(0, 0, 0, 0.65);
  color:#fff;
  font-family: Sunflower;
  font-size: 23px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;



 @media screen and (max-width: ${deviceSize.mobile}px){

		width: 120px;
 		height: 30px;
 		font-size: 12px;
 		padding: 0px 0px 0px 0px;
 		margin-top:10px;
 		text-align:center;
	 
	 }

`;





export function BusinessInquiriesForm(props){
const { bsize,lsize,tsize,Bg,mlsize} = props;




function sendEmail(e){

		 e.preventDefault();


		  emailjs.sendForm('service_8p496nh','template_gfj2v9o',e.target,'CTL-kv09HVMeu__61')
      .then((result) => {
          console.log(result.text);
      },(error) => {
          console.log(error.text);
      });

      e.target.reset();
 
 }

     

return(
	
	<FormContainer lsize={lsize} bsize={bsize} tsize={tsize} Bg={Bg} mlsize={mlsize}>
		
		<form onSubmit={sendEmail}>
	   <BusinessInquiries> Business Inquiries</BusinessInquiries>
	   	<Line>drop us a line, we're here to help.</Line>
	  
	   <div className="form-inputs">
	     <label htmlFor="name" className="form-label">
	   		<InputForm
	   		type="text" 
	   		name="name" 
	   		id="name"
	   		className='form-input'
	   		placeholder=" name *"
	   		/>
	   	</label>
	   </div>

	   <div className="form-inputs">
	   	<label htmlFor="company*" className="form-label"> 
	   		<InputForm
	   		type="text" 
	   		name="company"
	   		className='form-input'
	   		placeholder=" company *"
	   		/>
	   	</label>
	   	</div>


	   <div className="form-inputs">
	   	<label htmlFor="job tilte" className="form-label">
	   		<InputForm 
	   		type="text" 
	   		name="jobtitle"
	   		className='form-input'
	   		placeholder=" job title *"
	   		/>
	   	</label>
	   	  </div>

	   <div className="form-inputs">
	   	<label htmlFor="email" className="form-label">
	   		<InputForm
	   		type="text" 
	   		name="emailaddress"
	   		className='form-input'
	   		placeholder=" email address *"
	   		/>
	   	</label>
	   	</div>


	   <div className="form-inputs">
	   	<label htmlFor="phone number" className="form-label">
	   		<InputForm 
	   		type="text" 
	   		name="phonenumber"
	   		className='form-input'
	   		placeholder=" phone number *"
	   		/>
	   	</label>
	   	 </div>

	   <div className="form-inputs">
	   	<label htmlFor="email" className="form-label">
	   		<TxA 
	   		rows="10" 
	   		cols="32"
	   		type="textarea" 
	   		name="message"
	   		className='form-input'
	   		placeholder="message *"
	   		/>
	   	</label>
	   	</div>

	   		<SubmitButton>Submit</SubmitButton>
	   	</form>
	</FormContainer>

	);

}
